import { Callout, Link } from "zudoku/components";

export const GettingStartedCallout = () => (
  <Callout type="note" className="mb-5" title="Your API Keys">
    Below are the API keys that you have permissions to manage. To get started
    follow our detailed{" "}
    <Link to="/documentation/getting-started">Getting Started tutorial</Link>.
  </Callout>
);
